<template>
  <v-skeleton-loader
    :class="styleclass"
    :max-width="width"
    :type="type"
    v-if="condition"
  >
  </v-skeleton-loader>
</template>

<script>
export default {
  props: {
    width: String,
    type: String,
    condition: Boolean,
    styleclass: String,
  },
};
</script>

<style></style>
